import { utcToDisplayDate } from './timezones';

export const LOAD_APPT_EVENT_DATA = 'event-widgets/LOAD_APPT_EVENT_DATA';
export const LOAD_APPT_EVENT_STATUS = 'event-widgets/LOAD_APPT_EVENT_STATUS';
export const LOAD_CUSTOM_FIELDS = 'event-widgets/LOAD_CUSTOM_FIELDS';
export const LOAD_EXHIBITORS = 'event-widgets/LOAD_EXHIBITORS';

export function loadApptEventData(formatTime) {
  return async (dispatch, getState) => {
    const { accessToken, clients: { appointmentsClient }, event: { id } } = getState();
    if (id) {
      let appointmentEvent = await appointmentsClient.getApptEventDetails(accessToken, id);
      if (appointmentEvent && appointmentEvent.isValid) {
        appointmentEvent = {
          ...appointmentEvent,
          timeZone: getState().timezones[appointmentEvent.timeZone]
        };
      }
      dispatch({ type: LOAD_APPT_EVENT_DATA, payload: { appointmentEvent, formatTime } });
    }
  };
}

export function loadApptEventStatus() {
  return async (dispatch, getState) => {
    const { accessToken, clients: { appointmentsClient },
      event: { id, linkedAppointmentEvent } } = getState();
    if (linkedAppointmentEvent?.eventCode && id) {
      const appointmentEvent = await appointmentsClient.getApptEventInfo(accessToken, id);
      if (appointmentEvent.status) {
        const appointmentEventStatus = appointmentEvent.status;
        dispatch({ type: LOAD_APPT_EVENT_STATUS, payload: { appointmentEventStatus } });
      }
    }
  };
}

export function loadExhibitorsList(isGuest, customFieldIds) {
  return async (dispatch, getState) => {
    const { accessToken, clients: { appointmentsClient }, event: { id } } = getState();
    let exhibitors = isGuest ?
      await appointmentsClient.getGuestExhibitorsList(accessToken, id, customFieldIds) :
      await appointmentsClient.getExhibitorsList(accessToken, id);
    dispatch({ type: LOAD_EXHIBITORS, payload: { exhibitors } });
  };
}

export function getExhibitorCustomFields(isGuest, customFieldIds) {
  return async (dispatch, getState) => {
    const { accessToken, clients: { appointmentsClient }, event: { id } } = getState();
    const exhibitorCustomFields = isGuest ?
      await appointmentsClient.getGuestExhibitorCustomFields(accessToken, id, customFieldIds) :
      await appointmentsClient.getExhibitorCustomFields(accessToken, id);
    dispatch({ type: LOAD_CUSTOM_FIELDS, payload: { exhibitorCustomFields } });
  };
}

export default function appointmentsReducer(state = {
  appointmentEvent: undefined,
  exhibitors: [],
  exhibitorCustomFields: undefined,
  exhibitorCustomFieldsMap: {},
  appointmentEventStatus: undefined
}, action) {
  switch (action.type) {
    case LOAD_APPT_EVENT_DATA: {
      let appointmentEvent = { ...action.payload.appointmentEvent };
      if (action.payload.formatTime && appointmentEvent && appointmentEvent.isValid) {
        appointmentEvent.startTime = utcToDisplayDate(appointmentEvent.startTime, appointmentEvent.timeZone);
        appointmentEvent.endTime = utcToDisplayDate(appointmentEvent.endTime, appointmentEvent.timeZone);
      }
      return {
        ...state,
        appointmentEvent
      };
    }
    case LOAD_APPT_EVENT_STATUS: {
      return {
        ...state,
        appointmentEventStatus: action.payload.appointmentEventStatus
      };
    }
    case LOAD_CUSTOM_FIELDS: {
      let exhibitorCustomFieldsMap = {};
      action.payload.exhibitorCustomFields.forEach(field => {
        exhibitorCustomFieldsMap[field.question.id] = field.question;
      });
      return {
        ...state,
        exhibitorCustomFields: action.payload.exhibitorCustomFields,
        exhibitorCustomFieldsMap
      };
    }
    case LOAD_EXHIBITORS: {
      const exhibitors = [...action.payload.exhibitors].sort((a, b) => a.name.localeCompare(b.name))
        .map(exhibitor => {
          let answersMap = {};
          if (exhibitor.exhibitorCustomFields[0]) {
            exhibitor.exhibitorCustomFields[0].answeredQuestions.forEach(answer => answersMap[answer.id] = answer);
          }
          return { ...exhibitor, answersMap };
        });
      return {
        ...state,
        exhibitors
      };
    }
    default:
      return state;
  }
}
